import { Link } from "react-router-dom";
import { useAdmin } from "../../../contexts/AdminContext";

export default function GuterZweck() {
  const { settings } = useAdmin();
  const causes = settings.charities;
  const stats = settings.charityStats;

  return (
    <section id="guter-zweck" className="py-24 bg-[#0B1221] text-white relative overflow-hidden">
      
      {/* Background Decor */}
      <div className="absolute top-0 right-0 w-[800px] h-[800px] bg-emerald-900/10 blur-[150px] rounded-full translate-x-1/2 -translate-y-1/2 pointer-events-none" />
      <div className="absolute bottom-0 left-0 w-[600px] h-[600px] bg-amber-900/10 blur-[120px] rounded-full -translate-x-1/2 translate-y-1/2 pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-20">
          <div className="inline-flex items-center gap-2 mb-6">
            <span className="h-px w-8 bg-secondary/50"></span>
            <span className="uppercase text-secondary-light text-[10px] font-black tracking-[0.2em] relative">
              Guter Zweck
            </span>
            <span className="h-px w-8 bg-secondary/50"></span>
          </div>
          <h2 className="font-playfair text-4xl md:text-6xl font-black text-white leading-[1.1] mb-6">
            Haus gewinnen,<br />
            <span className="italic font-medium text-secondary-light">Leben verändern</span>
          </h2>
          <p className="text-white/60 text-lg md:text-xl font-medium leading-relaxed">
            Von jedem verkauften Los gehen <strong className="text-white">10 % des Preises</strong> an sorgfältig ausgewählte gemeinnützige Organisationen. Mitmachen heißt auch Gutes tun.
          </p>
        </div>

        {/* Impact Stats Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-8 mb-20">
          {stats.map((s, i) => (
            <div key={i} className="bg-white/5 border border-white/10 rounded-3xl p-6 md:p-8 text-center backdrop-blur-md shadow-2xl">
              <p className="font-playfair text-4xl md:text-5xl font-black text-primary-light mb-2">{s.value}</p>
              <p className="text-white/50 text-[10px] uppercase tracking-widest font-bold leading-relaxed">{s.label}</p>
            </div>
          ))}
        </div>

        {/* Causes Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8 mb-20">
          {causes.map((c, i) => (
            <div key={i} className="bg-[#151C2C] border border-[#232F46] rounded-[2rem] p-8 hover:border-secondary/30 transition-colors duration-300 flex flex-col items-start shadow-xl h-full">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-14 h-14 bg-[#1B293C] rounded-2xl flex items-center justify-center text-secondary-light border border-white/5 shadow-inner">
                  <i className={`${c.icon} text-2xl`}></i>
                </div>
                <div>
                  <h3 className="font-black text-lg text-white mb-1 tracking-tight">{c.org}</h3>
                  <p className="text-[9px] font-bold uppercase tracking-widest text-secondary">{c.category}</p>
                </div>
              </div>
              <p className="text-white/60 text-sm leading-relaxed mb-8 flex-1">
                {c.desc}
              </p>
              
              <div className="w-full pt-6 border-t border-white/10 flex items-center justify-between">
                <span className="text-[10px] font-bold text-white/40 uppercase tracking-widest">
                  Bereits gespendet
                </span>
                <span className="font-playfair italic font-black text-2xl text-primary-light">
                  {c.amount}
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div className="bg-emerald-900/20 border border-secondary/20 rounded-[2.5rem] p-10 md:p-16 text-center shadow-2xl overflow-hidden relative">
          <div className="absolute top-0 right-0 w-64 h-64 bg-secondary/20 blur-[100px] rounded-full translate-x-1/2 -translate-y-1/2"></div>
          
          <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-10">
            <div className="text-left md:max-w-md">
              <h3 className="text-2xl font-black text-white mb-3">Mitmachen und unterstützen</h3>
              <p className="text-white/60 text-sm leading-relaxed mb-4">
                Wir arbeiten ausschließlich mit zertifizierten und geprüften Organisationen zusammen. Jahresberichte auf Anfrage erhältlich.
              </p>
              <a href="#guter-zweck" className="inline-flex items-center gap-2 text-primary-light hover:text-primary-light text-sm font-bold transition-colors uppercase tracking-widest group">
                Mehr über unsere Aktionen erfahren
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
              </a>
            </div>
            
            <Link
              to="/forfaits"
              className="w-full md:w-auto flex items-center justify-center gap-3 bg-secondary hover:bg-secondary-light active:scale-[0.98] text-white font-black px-10 py-6 rounded-2xl transition-all duration-300 shadow-[0_20px_50px_rgba(16,185,129,0.3)] text-sm uppercase tracking-widest group"
            >
              <i className="ri-heart-pulse-fill text-lg group-hover:rotate-12 transition-transform"></i>
              Jetzt Mitmachen
            </Link>
          </div>
        </div>

      </div>
    </section>
  );
}
